<template>
  <div class="panel panel-default">
    <div class="panel-body">
      <p class="admin-page-description">
        Configuração de rematrícula da instituição: contratos modelo,
        períodos abertos pra renovação e regras de proposta. Crie novos
        períodos de rematrícula, gerencie contratos e acompanhe os
        alunos afetados.
      </p>
      <div class="reenrollment-view__header">
        <h4><strong>Observações:</strong></h4>

        <div class="dropdown">
          <button
            class="btn btn-primary dropdown-toggle"
            type="button"
            :id="`dropdown-reenrollment-contract-options-${this.institution.id}`"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="true"
          >
            Ações
            <span class="caret"></span>
          </button>
          <ul
            class="dropdown-menu dropdown-menu-right"
            :aria-labelledby="`dropdown-reenrollment-contract-options-${this.institution.id}`"
          >
            <li>
              <a @click="showCreateModal = true">
                Criar novo período de rematrícula
              </a>
            </li>
          </ul>
        </div>
      </div>
      <ul>
        <li>
          <strong>O valor alterado é o preço cheio da mensalidade</strong>
        </li>
        <li>
          Não deixar células da coluna 'Valor cheio novo' em branco ou preencher com valores não
          numéricos ou negativos.
        </li>
        <li>
          Cuidado com o formato dos números decimais,
          <strong>manter o mesmo formato da coluna 'Valor cheio atual' e não usar símbolo de moeda.</strong>
        </li>
        <li>
          As colunas <b>'Mês cobrança' e 'Ano cobrança'</b> são números. As mensalidades vão ser geradas com a data de
          vencimento a patir da junção desses dados
        </li>
      </ul>
      <create-reenrollment-contract-modal
        v-if="showCreateModal"
        @close="closeCreateModal"
      />
      <reenrollment-contracts-list />
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import CreateReenrollmentContractModal from './modals/CreateReenrollmentContractModal';
import ReenrollmentContractsList from './ReenrollmentContractsList';

export default {
  data() {
    return {
      showCreateModal: false,
    };
  },
  components: {
    CreateReenrollmentContractModal,
    ReenrollmentContractsList,
  },
  computed: {
    ...mapState([
      'institution',
    ]),
  },
  mounted() {
    this.fetchReenrollmentContracts();
  },
  methods: {
    ...mapActions([
      'loadReenrollmentContracts',
    ]),
    closeCreateModal() {
      this.showCreateModal = false;
      this.fetchReenrollmentContracts();
    },
    fetchReenrollmentContracts() {
      this.loadReenrollmentContracts(this.institution.id);
    },
  },

};
</script>
<style scoped lang="scss">
@import 'assets/stylesheets/utils/_spacing.sass';

.reenrollment-view__header {
  display: flex;
  justify-content: space-between;
  margin-bottom: $space-s;
}
</style>
